// extracted by mini-css-extract-plugin
module.exports = {"container":"nextMail_container__2GTH-"};